import { c as _c } from "react/compiler-runtime";
import type { FCl } from 'react-fc';
const Empty: FCl = t0 => {
  const $ = _c(4);
  const {
    className
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path stroke="currentColor" fill="none" d="m44 1.145 43 23.943v47.824L44 96.855 1 72.912V25.088z" />;
    t2 = <path fill="currentColor" d="M51.474 23.46a2 2 0 0 0-1.422-.593h-7.963v2h7.962l4.343 4.394 1.423-1.405-4.343-4.395Zm7.406 7.494-1.423 1.406 4.343 4.395v6.547h2v-6.547a2 2 0 0 0-.578-1.406zm4.92 17.443h-2V61.49h2zm0 18.19h-2v6.546h-6.45v2h6.45a2 2 0 0 0 2-2zm-13.35 8.546v-2h-12.9v2zm-17.8 0v-2H26.2v-6.022h-2v6.022a2 2 0 0 0 2 2zM24.2 63.067h2V51.022h-2zm0-16.09h2V34.934h-2v12.045Zm0-16.088h2v-6.022h7.963v-2H26.2a2 2 0 0 0-2 2z" />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] !== className) {
    t3 = <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 88 98" className={className}>{t1}{t2}</svg>;
    $[2] = className;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
};
export default Empty;